import { useTranslation } from "react-i18next";

export function useClientTranslation() {
  const { t, i18n } = useTranslation();

  // No hydration logic needed - this is a pure client-side app
  // Translations are bundled and available immediately
  return { t, i18n };
}
